var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path, _rect2, _circle8, _circle9, _rect3, _circle10, _circle11, _rect4, _path2, _circle12, _circle13, _circle14, _path3, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#2b3a6b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 18,
    r: 1.4,
    fill: "#fff",
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 14,
    r: 1.2,
    fill: "#fff",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 70,
    r: 1,
    fill: "#fff",
    opacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 60,
    r: 1.6,
    fill: "#fff",
    opacity: 0.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 0.9,
    fill: "#fff",
    opacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 100,
    r: 1.3,
    fill: "#fff",
    opacity: 0.7
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 8,
    r: 1,
    fill: "#fff",
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 124C14 98 34 90 60 90S106 98 106 124Z",
    fill: "#f4f1ea"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 98,
    width: 28,
    height: 14,
    rx: 4,
    fill: "#e8564a"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 105,
    r: 2,
    fill: "#f4f1ea"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 105,
    r: 2,
    fill: "#7fb8d6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 84,
    width: 24,
    height: 10,
    rx: 4,
    fill: "#d9d4c7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 52,
    r: 34,
    fill: "#f4f1ea"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 52,
    r: 34,
    fill: "none",
    stroke: "#d9d4c7",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 36,
    width: 44,
    height: 32,
    rx: 16,
    fill: "#1f3350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 44C48 40 56 39 62 40",
    stroke: "#9fd0ee",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 58,
    r: 2,
    fill: "#9fd0ee",
    opacity: 0.6
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 2.4,
    fill: "#f3ead6"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 54,
    r: 2.4,
    fill: "#f3ead6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 60Q60 64 65 60",
    stroke: "#f3ead6",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 48,
    width: 8,
    height: 12,
    rx: 3,
    fill: "#e8564a"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 48,
    width: 8,
    height: 12,
    rx: 3,
    fill: "#e8564a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait20);
export default __webpack_public_path__ + "static/media/player-portrait-20.eb7f458bcbf02addd7cd5eea5ebceb12.svg";
export { ForwardRef as ReactComponent };